export default "__VITE_ASSET__BIR0Ow2o__"